import React from 'react';
import { Combo } from 'fw/forms';
import * as API from 'modules/app/API'

class CertificationUnassignedCombo extends React.PureComponent {
    constructor(props) {
        super(props);
        this.state = {};
        this._isMounted = false;
    }

    completed = () => { return this._ctrl.completed(); }
    flag = () => { return this._ctrl.flag(); }

    componentWillReceiveProps = (nextProps) => {
        if (nextProps.queueTypeCode !== this.props.queueTypeCode)
            this.loadReviewers(nextProps.queueTypeCode);
    }

    componentDidMount = () => {
        this._isMounted = true;

        this.loadReviewers(this.props.queueTypeCode);
    }

    loadReviewers = (queueTypeCode) => {
        let rq = {
            queueTypeCode: queueTypeCode,
            certificationId: this.props.certificationId
        };

        API.Admin.get('/queue/getReviewerUsers', rq,
            {
                success: (r) => {
                    this._isMounted && this.setState({
                        items: r.data.items.map((item) => { return { label: item.fullName, value: item.userId } })
                    }, () => {
                        if (this.props.onLoad)
                            this.props.onLoad(r.data.reviewerId, r.data.reviewerAddress)
                    });
                }
            }, { block: false });
    }

    componentWillUnmount() {
        this._isMounted = false;
    }

    render() {
        return (
            <Combo
                {...this.props}
                placeholder={this.props.placeholder ? this.props.placeholder : "Assignee"}
                items={this.state.items}
                searchable={true}
                ref={(c) => { this._ctrl = c }} />
        )
    }
}

export default CertificationUnassignedCombo;

// Mark this as a form component
CertificationUnassignedCombo.defaultProps = {
    formControl: true,
    managed: false
};



// WEBPACK FOOTER //
// ./src/areas/shared/controls/certificationUnassignedCombo/CertificationUnassignedCombo.js